module.exports = __webpack_public_path__ + "adbc5b5e84d92c179520ac09aa3f27b4.png";


//////////////////
// WEBPACK FOOTER
// ./work/lebonchoix/img/two.png
// module id = 742
// module chunks = 0